import { useContext } from 'react'
import { LaborableContext } from './LaborableContext';

export const useLaborable = () => useContext(LaborableContext)